import HttpService from "./baseHttp";

//分页查询
export const HttpBespeakList = (data = {}) =>
    HttpService.get("/api/v2/ReserveInbound/findByPage", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
// 一键复制
export const HttpCopyOrderBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/copyOrder", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// 栏位数字
export const HttpBespeakSpan = (data = {}) =>
    HttpService.get("/api/v2/ReserveInbound/findStatusNum", { params: data });
//详情
export const HttpBespeak = (data = {}) =>
    HttpService.get("/api/v2/ReserveInbound/detail", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//编辑
export const HttpUpdateBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/edit", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//保存
export const HttpSaveBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/save", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//保存并提交
export const HttpSubmitBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/saveAndSubmit", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//卸货
export const HttpDischargeBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/discharge", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//Arrived
export const HttpArrivedBespeak = (data = {}) =>
HttpService.post("/api/v2/ReserveInbound/warehouseArrive", data, {
    baseURL: process.env.VUE_APP_APIURL_FBB,
});
//批量取消
export const HttpCancelBespeaks = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/batchCancel", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//更新
export const HttpBespeakUpdate = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/update", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//审批拒绝
export const HttpRefuseBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/approveRefuse", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//审批通过
export const HttpApprovedBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/approved", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//pickuo
export const HttpPickupDate = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/obtainEmptyContainerDate", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//取消申请
export const HttpCancelBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/cancelApply", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//管理员取消申请
export const HttpManageCancelBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/cancel", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//删除
export const HttpDelBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/delete", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//批量删除
export const HttpDelBespeaks = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/batchDelete", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//提交
export const HttpSubBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/submit", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//编辑提交
export const HttpEditSubBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/editAndSubmit", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//仓库下拉选择
export const HttpBespeakWarehouses = (data = {}) =>
    HttpService.get("/api/v2/ReserveInbound/selectOrgRoleWarehouses", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
// //批量导出
// export const HttpExportBespeak = (data = {}) => HttpService.get("/api/v2/ReserveInbound/batchExport", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//导出
export const HttpExportBespeak = (data = {}, config) =>
    HttpService.get("/api/v2/ReserveInbound/export", {
        ...config,
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//入库单信息带出
export const HttpBespeakInfo = (data = {}) =>
    HttpService.get("/api/v2/ReserveInbound/getInboundOrderInfo", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//入库单验证
export const HttpCheckBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/inboundOrderNoCheck", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//日志查看
export const HttpBespeakLog = (data = {}) =>
    HttpService.get("/api/v2/FbbOpLog/findByFilters", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

//确认发货日期
export const HttpDeliverBespeak = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/confirmAtWarehouse", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

//通过集装箱查计划单
export const HttpBespeakByContainerNo = (data = {}) =>
    HttpService.get("/api/v2/ReserveInbound/getInboundInfoByContainerNo", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// 根据箱号查询预约单是否可用
export const HttpCheckContainerNo = (data = {}) =>
    HttpService.post("/api/v2/ReserveInbound/checkByContainerNo", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// 卡车预约-列表，查看，创建/编辑
export const HttpTruckList = (data = {}) =>
    HttpService.get("/api/v2/truck/findByPage", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

export const HttpQueryTruckOne = (data = {}) =>
    HttpService.get("/api/v2/truck/detail", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

export const HttpSaveTruckOne = (data) =>
    HttpService.post("/api/v2/truck/create", data, {
        headers: { "Content-Type": "application/json" },
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

export const HttpTruckGetAmount = (data = {}) =>
    HttpService.post("/api/v2/truck/getAmount", data, {
        headers: { "Content-Type": "application/json" },
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// 列表的提交、妥投、取消
export const HttpSubmitTruckOne = (data = {}) =>
    HttpService.get("/api/v2/truck/submit", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpStockInTruckOne = (data = {}) =>
    HttpService.get("/api/v2/truck/stockIn", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpStockInTruckAll = (data = {}) =>
HttpService.get("/api/v2/truck/batchStockIn", {
    params: data,
    baseURL: process.env.VUE_APP_APIURL_FBB,
});
export const HttpCancelTruckOne = (data = {}) =>
    HttpService.get("/api/v2/truck/cancel", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpCOpyTruckOne = (data = {}) =>
    HttpService.get("/api/v2/truck/copy", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// 弹框内容：confirm,Inquiry,pu&DE,上传BOL，上传POD
export const HttpConfirmTruck = (data = {}) =>
    HttpService.post("/api/v2/truck/confirm", data, {
        headers: { "Content-Type": "application/json" },
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpInquiryTruckOne = (data) =>
    HttpService.post("/api/v2/truck/addInquiry", data, {
        headers: { "Content-Type": "application/json" },
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpPuDeTruckOne = (data) =>
    HttpService.post("/api/v2/truck/updateTime", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

export const HttpBOLTruck = (data = {}) =>
    HttpService.post("/api/v2/truck/uploadBol", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpPODTruck = (data = {}) =>
    HttpService.post("/api/v2/truck/uploadPod", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// b2b订单/other/Transport的请求
export const HttpQueryB2BOrderList = (data = {}) =>
    HttpService.get("/api/v2/truck/findTransfer", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpQueryB2BOrder = (data = {}) =>
    HttpService.get("/api/v2/truck/findByTransferId", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

export const HttpQueryTransportOrderList = (data = {}) =>
    HttpService.get("/api/v2/truck/findTransit", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpQueryTransportOrder = (data = {}) =>
    HttpService.get("/api/v2/truck/findByTransitId", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// b2c订单的请求，先获取列表接口，在请求单条，根据出库仓获取地址详情
export const HttpB2cAdminList = (data = {}, config) =>
    HttpService.get("/api/v2/DeliverOrder/findByPage", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_BOSS,
    });
export const HttpqueryB2COrder = (data = {}, config) =>
    HttpService.get("/api/v2/DeliverOrder/findOne", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_BOSS,
    });
export const HttpGetOrgWarehouseAdress = (data = {}) =>
    HttpService.get("/api/v2/address/findAddressesOfOrgWarehouseId", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// 根据组织请求对应的仓库列表
export const HttpUserManageWarehouse = (config) =>
    HttpService.post(
        "/api/v2/customerRate/getWarehouseByUser",
        { contextId: config || global.SYSID },
        { params: { contextId: config || global.SYSID } },
        { baseURL: process.env.VUE_APP_APIURL_FBB }
    );

export const HttpFilterDisabledWarehouse = (config) =>
    HttpService.get("/api/v2/organizationWarehouse/findOrgWarehousesByOrgId", {
        params: { contextId: config || global.SYSID },
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// 判断是否有相同单号
export const HttpGetcheckNo = (data = {}) =>
    HttpService.get("/api/v2/truck/checkNo", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// 卡车地址薄列表：发货、收货、失效启用
export const HttpDeliveryList = (data = {}) =>
    HttpService.get("/api/v2/LogisticsAddress/findByPage", {
        params: { type: 0, ...data },
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpReceiveList = (data = {}) =>
    HttpService.get("/api/v2/LogisticsAddress/findByPage", {
        params: { type: 1, ...data },
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpIsAcctive = (data = {}) =>
    HttpService.get("/api/v2/LogisticsAddress/active", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// 获取详情，保存更新
export const HttpGetAddressDetail = (data = {}) =>
    HttpService.get("/api/v2/LogisticsAddress/detail", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpSaveAddress = (data) =>
    HttpService.post("/api/v2/LogisticsAddress/saveAndUpdate", data, {
        headers: { "Content-Type": "application/json" },
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

// 预约单查询地址薄列表
export const HttpCheckAddressList = (data = {}) =>
    HttpService.get("/api/v2/LogisticsAddress/findAll", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });


//加价率列表、查看、编辑、删除
export const HttpMarkUpRateList = (data = {}) =>
    HttpService.get("/api/v2/truckRate/findByPage", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

export const HttpMarkUpRateOne = (data = {}) =>
    HttpService.get("/api/v2/truckRate/detail", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });

export const HttpSaveMarkUpRate = (data) =>
    HttpService.post("/api/v2/truckRate/create", data, {
        headers: { "Content-Type": "application/json" },
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
export const HttpDeleteMarkUpRate = (data = {}) =>
    HttpService.get("/api/v2/truckRate/delete", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
    });
//加价率导入
export const HttpImportMarkUpRate = (data, config) =>
    HttpService.post("/api/v2/truckRate/importData", data, {
        baseURL: process.env.VUE_APP_APIURL_FBB,
        ...config,
    });
// 加价率模板下载
export const HttpDownloadMarkUpRateTemplate = (data, config) =>
    HttpService.get("/api/v2/truckRate/importTemplate", {
        params: data,
        baseURL: process.env.VUE_APP_APIURL_FBB,
        ...config,
    });

// 新的日历用到的接口
// 看板日历、底部折现图、侧边栏
export const HttpGetDateReport = (data) => HttpService.post('/api/v2/ReserveWarehouseCfg/dateReport', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpGetReserveCount = (data) => HttpService.post('/api/v2/ReserveWarehouseCfg/getReserveCount', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpGetListByDate = (data) => HttpService.post('/api/v2/ReserveInbound/getListByDate', data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 客户可约数据详情日历
export const HttpgetDateReserveQtyByClient = (data) => HttpService.post('/api/v2/ReserveInbound/getDateReserveQtyByClient', data, { baseURL: process.env.VUE_APP_APIURL_FBB });



// 数据配置 列表、查看编辑、删除
export const HttpDataConfigList = (data = {}) => HttpService.get("/api/v2/ReserveWarehouseCfg/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpGetDataConfigOne = (data = {}) => HttpService.get("/api/v2/ReserveWarehouseCfg/detail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSaveDataConfigOne = (data) => HttpService.post('/api/v2/ReserveWarehouseCfg/save', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpDeleteDataConfigOne = (data = {}) => HttpService.get("/api/v2/ReserveWarehouseCfg/delete", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取仓库配置的查看详情/操作日志
export const HttpGetDataConfigQuery = (data = {}) => HttpService.get("/api/v2/ReserveWarehouseCfg/findOneDetail", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 新增预约单号查询
export const HttpGetOrderInfo = (data = {}) => HttpService.get("/api/v2/ReserveInbound/getOrderInfo", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });


// 配置仓库接口（针对当前用户所拥有的的仓库）
export const HttpGetOurWarehouseList = (data = {}) => HttpService.get("/api/v2/warehouse/findWarehouseByUser", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 根据日期和仓库请求预约总量
export const HttpGetReserveDataByDate = (data) => HttpService.post('/api/v2/ReserveInbound/getReserveDataByDate', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 供应商列表
export const HttpGetSystemSupplierList = (data = {}) => HttpService.get("/api/v2/systemSupplier/findAllByHostOrgId", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 查询所有计费条件
export const HttpGetAllBillingCondition = (data = {}) => HttpService.get("/api/v2/newBilling/billing/getAllBillingCondition", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 查询计费单位
export const HttpGetBillingUnit = (data = {}) => HttpService.get("/api/v2/newBilling/billing/getBillingUnit", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 针对计费单位查询计费条件
export const HttpGetBillingCondition = (data = {}) => HttpService.get("/api/v2/newBilling/billing/getBillingCondition", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 查询计费单位的字典
export const HttpGetBillingUnitCondition = (data = {}) => HttpService.get("/api/v2/newBilling/billing/getBillingUnitCondition", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 卡车各tab页统计数量
export const HttpGetTruckNumber = (data = {}) => HttpService.post("/api/v2/truck/getCountByStatus", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 卡车托盘明细列表
export const HttpGetTruckPalletList = (data = {}) => HttpService.get("/api/v2/truckPallet/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 卡车编辑询价
export const HttpTruckEnquiryEdit = (data = {}) => HttpService.post("/api/v2/truck/editInquiry", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
